import React, { useCallback, useState, useRef, useMemo, useEffect } from 'react';
import { Grid } from 'antd';
import { useSelector } from 'react-redux';
import indexStyles from '../index.less';
import { localeSelector } from 'src/selector/app';
import { JoinClassName } from 'src/utils/utils';
import Image from 'next/image';
import CommonSection from '../CommonSection';
import FrozenRatio from 'src/components/FrozenRatio/FrozenRatio';
import UnoptimizedImage from 'src/components/UnoptimizedImage';

const { useBreakpoint } = Grid;
const UsingServiceAdvantage = ({ content, productMode = false }) => {
  const screens = useBreakpoint();
  // const local = useSelector(localeSelector);
  let [activeIndex, setActiveIndex] = useState(0);
  let [autoTrigger, setAutoTrigger] = useState(true);
  let [containerHeight, setContainerHeight] = useState('auto');
  let timerRef = useRef(null);
  const leftItemListRef = useRef(null);
  let onMouseEnter = useCallback((event) => {
    let activeIndex = event.currentTarget.getAttribute('data-index');
    setActiveIndex(Number.parseInt(activeIndex));
    timerRef.current && clearTimeout(timerRef.current);
    setAutoTrigger(false);
  }, []);

  let onMouseLeave = useCallback((event) => {
    // setActiveIndex(-1);
    setAutoTrigger(true);
  }, []);

  useEffect(() => {
    if (leftItemListRef.current) {
      let { height } = leftItemListRef.current.getBoundingClientRect();
      setContainerHeight(height);
    }
  }, [screens]);

  if (screens.xs || (screens.sm && !screens.md)) {
    return <UsingServiceAdvantageForMobile content={content} productMode={productMode} />;
  }

  return (
    <CommonSection
      title={content.title}
      desc={content.desc}
      className={indexStyles.max1440Width}
      outerClassName={JoinClassName(indexStyles.whiteBackgroundcolor, indexStyles.usingServiceAdvantageSection)}
    >
      <div
        className={JoinClassName(indexStyles.usingServiceAdvantage)}
        style={!content.title && !content.desc ? { marginTop: 0 } : {}}
      >
        <div className={JoinClassName(indexStyles.leftItemList)} ref={leftItemListRef}>
          {content.items.map(({ title, image, items }, index) => {
            let local_title = title;

            return (
              <div
                className={JoinClassName(
                  indexStyles.serviceAdvantagePoint,
                  activeIndex === index ? indexStyles.active : ''
                )}
                data-index={index}
                key={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
              >
                <h3 className={JoinClassName(indexStyles.advantagePointTitle)}>{local_title}</h3>
                <div className={JoinClassName(indexStyles.advantageItemList)}>
                  {items.map(({ desc, title, items }, index) => {
                    if (items && Array.isArray(items) && items.length !== 0) {
                      return (
                        <div key={`${index}@advantageItem`}>
                          <span className={JoinClassName(indexStyles.advantagePointSubTitle)}>{title}</span>
                          {items.map(({ desc }, index) => {
                            return (
                              <p key={index} className={JoinClassName(indexStyles.advantagePointDesc)}>
                                {desc}
                              </p>
                            );
                          })}
                        </div>
                      );
                    }
                    return (
                      <p key={index} className={JoinClassName(indexStyles.advantagePointDesc)}>
                        {desc}
                      </p>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <div
          className={JoinClassName(indexStyles.rightImageContainer)}
          style={{ minHeight: containerHeight, overflow: 'hidden' }}
        >
          {content.items.map(({ title, image, covers, items }, index) => {
            let local_title = title;
            let imagesrc = image || covers;
            let isActived = activeIndex === index;
            if (Array.isArray(imagesrc)) {
              return (
                <div
                  className={JoinClassName(
                    indexStyles.advantagePointMultipsImage,
                    isActived ? indexStyles.advantagePointImageActive : ''
                  )}
                  key={index}
                >
                  {imagesrc.map(({ src, ratio }, index) => {
                    return (
                      <FrozenRatio ratio={ratio} key={index}>
                        <UnoptimizedImage src={src} layout="fill" objectFit="contain" alt={local_title} />
                      </FrozenRatio>
                    );
                  })}
                </div>
              );
            } else {
              // let isActived = false;
              return (
                <div
                  className={JoinClassName(
                    indexStyles.advantagePointImage,
                    isActived ? indexStyles.advantagePointImageActive : ''
                  )}
                  key={index}
                >
                  <UnoptimizedImage
                    src={imagesrc}
                    layout="fill"
                    objectFit="cover"
                    alt={local_title}
                    style={{ borderRadius: '16px' }}
                  />
                </div>
              );
            }
          })}
        </div>
      </div>
    </CommonSection>
  );
};

const UsingServiceAdvantageForMobile = ({ content, productMode }) => {
  const screens = useBreakpoint();
  const local = useSelector(localeSelector);
  const leftItemListRef = useRef(null);

  return (
    <CommonSection
      title={content.title}
      desc={content.desc}
      outerClassName={JoinClassName(indexStyles.whiteBackgroundcolor, indexStyles.usingServiceAdvantageSection)}
    >
      <div className={JoinClassName(indexStyles.usingServiceAdvantage, indexStyles.productMode)}>
        <div className={JoinClassName(indexStyles.leftItemList)} ref={leftItemListRef}>
          {content.items.map(({ title, image, covers, items }, index) => {
            let local_title = title;
            let imagesrc = image || covers;
            return (
              <div className={JoinClassName(indexStyles.serviceAdvantagePoint)} data-index={index} key={index}>
                <div className={JoinClassName(indexStyles.advantagePointTop)}>
                  {Array.isArray(imagesrc) &&
                    imagesrc.map(({ src, ratio }, index) => {
                      return (
                        <FrozenRatio ratio={ratio} key={index}>
                          <UnoptimizedImage src={src} layout="fill" objectFit="cover" alt={local_title} />
                        </FrozenRatio>
                      );
                    })}
                  {!Array.isArray(imagesrc) && (
                    <FrozenRatio ratio={186 / 343}>
                      <UnoptimizedImage src={imagesrc} layout="fill" objectFit="cover" alt={local_title} />
                    </FrozenRatio>
                  )}
                </div>
                <div className={JoinClassName(indexStyles.advantagePointBottom)}>
                  <h3 className={JoinClassName(indexStyles.advantagePointTitle)}>{local_title}</h3>
                  <div className={JoinClassName(indexStyles.advantageItemList)}>
                    {items.map(({ desc, title, items }, index) => {
                      if (items && Array.isArray(items) && items.length !== 0) {
                        return (
                          <div>
                            <span className={JoinClassName(indexStyles.advantagePointSubTitle)}>{title}</span>
                            {items.map(({ desc }) => {
                              return (
                                <p key={index} className={JoinClassName(indexStyles.advantagePointDesc)}>
                                  {desc}
                                </p>
                              );
                            })}
                          </div>
                        );
                      }
                      return (
                        <p key={index} className={JoinClassName(indexStyles.advantagePointDesc)}>
                          {desc}
                        </p>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </CommonSection>
  );
};

export default UsingServiceAdvantage;
